// css
import '../../scss/pages/page-careers.scss';

// utils
import foundation from '../_utils/foundation';

document.addEventListener('DOMContentLoaded', () => {
	foundation();
});

window.addEventListener('load', () => {});
